import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Contribute({onClose}) {
  return (
    

  <div className="modalStyle text-center px-3 mt-24" >
      <div style={{ textAlign: 'right' }} onClick={onClose}>
        <button>X</button>
      </div>
    <div style={{backgroundColor:'#6B728E',marginRight:'10%',marginLeft:'10%', }} className="grid h-1"></div>
        <h1 className="lg:text-4xl font-bold  my-6" style={{fontWeight:'600',fontSize:'27px',fontFamily:'raleway'}}>Life Long 365!</h1>
         <p className='pb-6 ' style={{fontSize:'17px',fontWeight:'400',fontFamily:'raleway'}}> when learning is a lifelong pursuit it is easy to be more informed, innovative, and successful in the society.</p>
         <Link to='/login'><button style={{borderRadius:'0px'}} className="btn btn-outline btn-info px-12 mb-6">Login Now</button></Link>
    <div style={{backgroundColor:'#6B728E',marginRight:'20%',marginLeft:'20%'}} className="grid h-1 mb-6"></div>
  </div>

  )
}

export default Contribute